import React from 'react';
import solutionIcon1 from '../../assets/imgs/awsSolution1.svg';
import solutionIconLine1 from '../../assets/imgs/awsSolutionLine1.svg';
import solutionIcon2 from '../../assets/imgs/awsSolution2.svg';
import solutionIconLine2 from '../../assets/imgs/awsSolutionLine2.svg';
import solutionIcon3 from '../../assets/imgs/awsSolution3.svg';
import solutionIconLine3 from '../../assets/imgs/awsSolutionLine3.svg';
import solutionIcon4 from '../../assets/imgs/awsSolution4.svg';
import solutionIconLine4 from '../../assets/imgs/awsSolutionLine4.svg';
import solutionIcon5 from '../../assets/imgs/awsSolution5.svg';
import solutionIconLine5 from '../../assets/imgs/awsSolutionLine5.svg';
import solutionIcon6 from '../../assets/imgs/awsSolution6.svg';
import solutionIconLine6 from '../../assets/imgs/awsSolutionLine6.svg';

const solutionData = [
  {
    title: `생성형 AI를 위한 최적의 플랫폼`,
    enTitle: `
Generative AI Solutions`,
    titleColor: '#85613A',
    themeColor: '#4A4A4A',
    icon: solutionIcon1,
    lineIcon: solutionIconLine1,
    contentTitle:
      '생성형 AI와 멀티모달 AI 애플리케이션을 쉽고 빠르게 구축할 수 있는 환경 제공.',
    contentData: [
      'Amazon Bedrock 등 최신 AI 서비스를 통해 혁신적인 비즈니스 전환을 지원합니다.',
    ],
  },
  {
    title: `최신 고성능 인프라 제공`,
    enTitle: `
High-performance infrastructure Solutions`,
    titleColor: '#1161BD',
    themeColor: '#1372DE',
    icon: solutionIcon2,
    lineIcon: solutionIconLine2,
    contentTitle:
      'Graviton4 등 최신 프로세서를 기반으로, 웹 서비스와 데이터베이스 구동 시 뛰어난 성능과 비용 효율을 동시에 실현합니다.',
    contentData: [],
  },
  {
    title: `대규모 데이터 분석을 위한 스토리지 성능`,
    enTitle: `Data Analysis Solutions`,
    titleColor: '#FF7548',
    themeColor: '#FF7B42',
    icon: solutionIcon3,
    lineIcon: solutionIconLine3,
    contentTitle:
      'S3 테이블 서비스를 통해 기존 대비 최대 3배 빠른 처리와 10배 높은 TPS를 제공',
    contentData: [
      'AI 학습, 로그 분석 등 빅데이터 환경에 최적화된 스토리지 옵션을 제공합니다.',
    ],
  },
  {
    title: `개발자 생산성 향상 도구`,
    enTitle: `Increase Development Efficiency Solutions`,
    titleColor: '#464646',
    themeColor: '#4A4A4A',
    icon: solutionIcon4,
    lineIcon: solutionIconLine4,
    contentTitle:
      'Amazon Q Developer 등 AI 기반 도구로 코드 리뷰, 테스트 자동화, 문서 정리를 지원.\n',
    contentData: [
      '개발 효율을 높이고 운영 리소스를 줄일 수 있는 스마트 개발 환경을 제공합니다.',
    ],
  },
  {
    title: `글로벌 서비스 확장에 강한 인프라`,
    enTitle: `Global Service Expansion Solutions`,
    titleColor: '#4C93FF',
    themeColor: '#31E89F',
    icon: solutionIcon5,
    lineIcon: solutionIconLine5,
    contentTitle:
      '30개 이상 리전, 수백 개의 가용영역(AZ)을 갖춘 AWS 글로벌 인프라를 통해 전 세계 어디서든 빠르고 안정적인 서비스 제공이 가능합니다.\n',
    contentData: [],
  },
  {
    title: `포괄적인 보안 및 규제 준수 체계`,
    enTitle: `Security And Regulation Solutions`,
    titleColor: '#FF7E77',
    themeColor: '#FF8A6A',
    icon: solutionIcon6,
    lineIcon: solutionIconLine6,
    contentTitle: '143개 이상 글로벌 규정과 300여 개 보안 기능 내장.',
    contentData: [
      '금융, 의료, 공공 등 규제 산업에서도 신뢰할 수 있는 보안 환경을 보장합니다.',
    ],
  },
];
const AwsModalContents = ({ solutionActiveIndex }) => {
  return (
    <div className="modalWrap naverModalContent">
      <div className="flex-col gap-16 serviceDescription">
        <div
          style={{
            backgroundColor: solutionData[solutionActiveIndex].themeColor,
          }}
          className="colorBox flex-col  align-end justify-between"
        >
          <div className="titleWrap">
            <span>{solutionData[solutionActiveIndex].enTitle}</span>
          </div>
          <div className="iconWrap">
            <img src={solutionData[solutionActiveIndex].lineIcon} alt="" />
          </div>
        </div>
        <div className="contentsBox px-24 flex-full gap-32 py-32 flex-col">
          <div className="contentTitle">
            <span> {solutionData[solutionActiveIndex].contentTitle}</span>
          </div>
          <div className="divide "></div>
          <div className="contentsList flex-col gap-32">
            {solutionData[solutionActiveIndex].contentData.map((item, i) => {
              return (
                <div className={'flex-row align-center gap-24'}>
                  <div className={`contentNum`}>
                    <span>0{i + 1}</span>
                  </div>
                  <div className="content">
                    <span>{item}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

AwsModalContents.headerTitle = 'ddd';

export default AwsModalContents;
